import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError, getUtm, track } from "@/lib/api";
import { CONSENT_TEXT } from "@/data/siteContent";

export function useLeadSubmit(type) {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const submit = async (data, extras = {}) => {
    setSubmitting(true);
    setError("");
    try {
      await api.post("/leads", {
        type,
        data,
        consent: extras.consent,
        source_page: window.location.pathname,
        referral_source: extras.referral_source || "",
        utm: getUtm(),
        company: extras.company || "",
      });
      track(`${type}_form_complete`);
      navigate(`/thank-you?type=${type}`);
    } catch (err) {
      const msg = formatApiError(err);
      setError(msg);
      toast.error(msg);
      setSubmitting(false);
    }
  };

  return { submit, submitting, error, setError };
}

export function ConsentCheckbox({ checked, onChange, error, testid }) {
  return (
    <div data-testid={`${testid}-consent-group`}>
      <label className="flex items-start gap-3 cursor-pointer min-h-[48px]">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-1 h-5 w-5 shrink-0 rounded border-input accent-[#0B1B3D]"
          aria-describedby={`${testid}-consent-text`}
          data-testid={`${testid}-consent-checkbox`}
        />
        <span id={`${testid}-consent-text`} className="text-sm text-mutedink leading-relaxed">
          {CONSENT_TEXT} See our{" "}
          <a href="/privacy" className="text-navy underline">Privacy Policy</a> and{" "}
          <a href="/terms" className="text-navy underline">Terms of Use</a>.
        </span>
      </label>
      {error && <p className="mt-1.5 text-sm font-semibold text-red-700" role="alert" data-testid={`${testid}-consent-error`}>{error}</p>}
    </div>
  );
}

export function Honeypot({ value, onChange }) {
  return (
    <div className="absolute left-[-9999px] top-0" aria-hidden="true">
      <label>
        Company
        <input type="text" tabIndex={-1} autoComplete="off" value={value} onChange={(e) => onChange(e.target.value)} />
      </label>
    </div>
  );
}

export function FieldError({ id, message }) {
  if (!message) return null;
  return <p id={id} className="mt-1.5 text-sm font-semibold text-red-700" role="alert">{message}</p>;
}
